import React, { useState } from 'react';
import * as Yup from 'yup';
import { Formik } from 'formik';
import { useNavigate } from 'react-router';
import './pin-setup-form.scss'
import { setPin } from '../../../services/users';
import { toast } from 'react-toastify';

const pinSchema = Yup.object().shape({
  pin: Yup.string()
    .required('PIN is required')
    .min(5, 'PIN must be exactly 5 characters')
    .max(5, "PIN must be exactly 5 characters")
    .matches(
      /^([a-zA-Z0-9]){0,5}/,
      'PIN should be alphanumeric. No special characters allowed'
    ),
  rePin: Yup.string()
    .required('PIN is required')
    .min(5, 'PIN must be exactly 5 characters')
    .max(5, "PIN must be exactly 5 characters")
    .matches(
      /^([a-zA-Z0-9]){0,5}/,
      'PIN should be alphanumeric. No special characters allowed'
    )
    .oneOf([Yup.ref('pin'), null], "PINs don't match!"),
});

const PinSetupForm = ({ userId }) => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);

  const handleSubmit = (values) => {
    setIsLoading(true);
    setPin(values).then(res => {
      if(res.status_code == 200 || res.status_code == 201) {
        toast(`${res.message}. You can close this page and return to the app`);
        setMessage(res.message);
      }else {
          toast(`Sorry! ${res.message}`);
          setErrorMessage(res.message);
          setMessage(res.message);
      }
    }).catch(err => {
      toast(`Sorry, ${err.message}`)
      setErrorMessage(err.message);
      setMessage(err.message);
    }).finally( () => {
      setIsLoading(false);
      setFormSubmitted(true);
    })
  };

  return  (
    <div className="login-form">
      <div className="login-error">{ errorMessage ? errorMessage : ''}</div>
      { !formSubmitted &&
        <Formik
        initialValues={{
          pin: "",
          rePin: "",
          id: userId
        }}
        onSubmit={(values) => {
          handleSubmit(values);
        }}
        validationSchema={pinSchema}
      >
        {({ handleSubmit, values, handleChange, errors, touched }) => (
          <form onSubmit={handleSubmit}>
            <div className={`field`}>
              <label htmlFor="pin">PIN code</label>
              <input
                name="pin"
                id="pin"
                type='password'
                placeholder="Enter PIN"
                value={values.pin}
                onChange={handleChange}
              />
              {errors.pin && touched.pin ? (
                <div className="error">{errors.pin}</div>
              ) : null}
            </div>
            <div className={`field`}>
              <label htmlFor="rePin">Confirm PIN</label>
              <input
                type='password'
                name="rePin"
                id="rePin"
                placeholder="Confirm PIN"
                value={values.rePin}
                onChange={handleChange}
              />
              {errors.rePin && touched.rePin ? (
                <div className="error">{errors.rePin}</div>
              ) : null}
              {/* <Link to={"/"} className={'forgot-password'}>Forgot password?</Link> */}
            </div>
            <button type="submit" disabled={isLoading}>
              {!isLoading && <span>CONFIRM</span>}
              {isLoading && <span>Validating ...</span>}
              {/* {isLoading && <Loader />} */}
            </button>
          </form>
        )}
        </Formik>
      }
      {
        formSubmitted && 
        <p className='login-info'>
          {message}
        </p>
      }
    </div>
  );
};

export default PinSetupForm;
